import React, { useState, useEffect } from 'react';

// custom components
import { SearchBar } from "_atoms";

// bootstrap
import { Dropdown } from 'react-bootstrap';

// redux
import { useSelector, useDispatch } from "react-redux";
import {
    setEmployeeFilter,
    selectEmployeeFilter,
    setEmployeeSearch,
    selectEmployeeSearchTerm,
    selectEmployeeSearchFilter,
    selectAddEmployeeStatus,
    resetAddEmployeeForm
} from "_redux/slices/timeline/employees";
import { setSearchedFlight, selectSearchedFlight } from '_redux/slices/timeline/flight-information-list';
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import {
    selectBookingSearch,
    selectTaskStatusFilter,
    setBookingSearch,
    setTaskStatusFilter
} from '_redux/slices/timeline/timeline-data';

// styling
import { Spacing } from "_styles";
import { EmployeeInformationColumnWidth } from "../timeline-constants";

const TimelineToolbar = () => {

    //#region redux
    const dispatch = useDispatch();

    const employeeFilter = useSelector(selectEmployeeFilter);
    const searchTerm = useSelector(selectEmployeeSearchTerm);
    const employeeSearchFilter = useSelector(selectEmployeeSearchFilter);
    const addEmployeeStatus = useSelector(selectAddEmployeeStatus);
    const taskStatusFilter = useSelector(selectTaskStatusFilter);
    const searchedFlight = useSelector(selectSearchedFlight);
    const bookingSearch = useSelector(selectBookingSearch);
    const usedTheme = useSelector(selectUsedTheme);
    //#endregion

    //#region local states    
    const [showAddModal, setShowAddModal] = useState(false);
    //#endregion

    //#region useEffect
    useEffect(() => {
        dispatch(setEmployeeFilter("online"))   // default to online
        dispatch(setBookingSearch(""));
        dispatch(setSearchedFlight(""));
    }, []);

    useEffect(() => {
        if (addEmployeeStatus === "succeeded") {
            handleCloseModal();
        }
    }, [addEmployeeStatus]);
    //#endregion

    //#region functions
    const handleCloseModal = () => {
        dispatch(resetAddEmployeeForm());
        setShowAddModal(false);
    };

    const handleSearch = (val) => {
        if (val?.target?.value) {
            let searchValue = val?.target?.value?.replace(/\s+/g, '');
            const flightNumberRegex = /^([A-Za-z]{1,3}\d{2,4}[A-Za-z]?|\d+)$/i;
            if (flightNumberRegex.test(searchValue)) {
                dispatch(setSearchedFlight(searchValue));
                dispatch(setBookingSearch(""));
            } else {
                dispatch(setBookingSearch(searchValue));
            }
        } else {
            dispatch(setSearchedFlight(""));
            dispatch(setBookingSearch(""));
        }
    };

    const handleEmployeeSearch = (searchedValue) => {
        dispatch(setEmployeeFilter(searchedValue));
        dispatch(setEmployeeSearch(""));
    };
    //#endregion

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            backgroundColor: usedTheme.BACKGROUND_COLOR,    
        }}>

            {/* employee search filter */}
            <div style={{ display: 'flex', padding: Spacing.SCALE_4, flex: 1 }}>
                <SearchBar
                    employee={true}
                    onChange={(event) => dispatch(setEmployeeSearch(event.target.value))}
                    placeholder={`Employee Filter`}
                    value={searchTerm}
                    timeline={true}
                />
            </div>

        </div>
    );
};

export default TimelineToolbar;
